<template>
    <div class="body">
        <div :style="{'display':refund}">
            <p>退款说明/拒绝理由</p>
            <el-input class="refundInfo" type="textarea" :rows="5" placeholder="请输入内容" v-model="form.reason"></el-input>
            <br/>
            <p class="refundButtom">
                    <el-button type="primary" @click="sendRefund(true)">确认退款</el-button>
                    <el-button type="primary" @click="sendRefund(false)">拒绝退款</el-button>
            </p>
        </div>
        <div>
                <el-timeline class="timeline">
                    <el-timeline-item v-for="(item,index) in list" :key="index"  :timestamp="item.time" placement="top">
                        <el-card>
                            <h4>{{item.status}}</h4>
                            <p>提交于{{item.time}}</p>
                        </el-card>
                    </el-timeline-item>
                </el-timeline>
        </div>
       
        
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('product')
export default {
    data(){
        return{
            form:{
               id:69,
               consent:false,
               reason:'',  
            },
            refund:'none',
            textarea: '',
            list:[]
        }
    },
    mounted(){
       console.log(this.orderRefundInfo)
       console.log(this.orderId)
       this.form.id = this.orderRefundInfo.id
       this.home()
    },
    computed:{
      ...mapState({
         orderId:state=>state.orderId,
         orderRefundInfo:state=>state.orderRefundInfo,
      })
    },
    methods:{
        home(){
           this.joker.store.refundInfo(this.form.id).then(res=>{
               if(res.content.statusCode==10){
                   this.refund = 'block'
               }
               this.list = res.content.aliLogistics.list
           })
        },
        sendRefund(item){
            this.form.consent = item
            this.joker.store.sendRefund(this.form).then(res=>{
                console.log(res)
                if(res.success){
                    alert("操作成功!")
                    this.home()
                }else{
                    alert(res.message)
                }
            })
        },
    }
}
</script>

<style scoped>
.refundInfo{
    width: 50%;
}

.refundButtom{
    margin-top: 1%
}

.timeline{
    width: 50%;
    margin-left: 25%;
}

.time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }

  .card{
      margin-left: 5%;
  }

 .number{
    margin-top: 5%;
    font-size: 15px;
 }
  .price{
     color: red;
  }

</style>


// WEBPACK FOOTER //
// src/components/Store/Order/OrderRefund.vue